import React from 'react';
import ReactDOM from 'react-dom/client';
import './global.css';
import { App } from './app/App';
import { initKeycloak } from './auth/keycloak';
import { setServerUserId } from './auth/useUser';
import { fetchMe } from './api/me';
import { UIStateProvider } from './state/contexts/UIStateContext';
import { AppDataProvider } from './state/contexts/AppDataContext';

(async () => {
  try {
    await initKeycloak();
  } catch (err) {
    document.body.innerText = `Authentication failed: ${(err as Error).message}`;
    return;
  }
  // Resolve the server-side users.id before first render so dual-control
  // guards compare principals in one ID space (B-2). On failure the guards
  // stay conservative client-side; the DB CHECK still enforces.
  try {
    setServerUserId((await fetchMe()).id);
  } catch (err) {
    console.error('GET /api/v1/me failed — dual-control UI guards degraded', err);
  }
  ReactDOM.createRoot(document.getElementById('root')!).render(
    <React.StrictMode>
      <UIStateProvider>
        <AppDataProvider>
          <App />
        </AppDataProvider>
      </UIStateProvider>
    </React.StrictMode>,
  );
})();
